import { useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { Button } from '@wordpress/components';
import { __experimentalHStack as HStack, __experimentalText as Text } from '@wordpress/components';
import { __experimentalToolsPanel as ToolsPanel, __experimentalToolsPanelItem as ToolsPanelItem,
    Icon, __experimentalToggleGroupControl as ToggleGroupControl,
    __experimentalToggleGroupControlOption as ToggleGroupControlOption
} from '@wordpress/components';
import  { ReactComponent as Icon11 } from '../../../../inc/assets/img/11.svg';
import { Bgclr, BgImg} from '../../helpers/icon.js';
import { Bordercontrol } from './bordercontrol.js';
import { Radiuscontrol } from './radiuscontrol.js';
import {Gradient}  from './gradient.js';
import {Image} from './image.js';
import {ImageControl} from './imagecontrol.js';
import { VayuBlocksDeviceControl } from '@vayu-blocks/device-control';

// "frameData":{
//         "type": "object",
//         "default":{
//             "active":"color",
//             "border":{
//                 "Desktop": {},
//                 "Tablet": {},
//                 "Mobile": {}
//             },
//             "radius":{
//                 "Desktop": {},
//                 "Tablet": {},
//                 "Mobile": {}
//             },
//             "gradient":{
//                 "color":"linear-gradient(135deg,rgb(74,234,220) 0%,rgb(151,120,209) 20%,rgb(207,42,186) 40%,rgb(238,44,130) 60%,rgb(251,105,98) 80%,rgb(254,248,76) 100%)",
//                 "width":{
//                     "Desktop": {},
//                     "Tablet": {},
//                     "Mobile": {}
//                 }
//             },
//             "image":{
//                 "url":"",
//                 "width":{
//                     "Desktop": {},
//                     "Tablet": {},
//                     "Mobile": {}
//                 },
//                 "place":{
//                 "Desktop": {},
//                 "Tablet": {},
//                 "Mobile": {}
//                 },
//                 "size":{
//                 "Desktop": {},
//                 "Tablet": {},
//                 "Mobile": {}
//                 },
//                 "type":"space",
//                 "customImage":"",
//                  "opacity" : 0.5,
//             }

//         }
// }

export const VayuBlockBorderFrame = ({
    frameData = { 
        active: 'color', 
        border: { Desktop: {}, Tablet: {}, Mobile: {}}, 
        radius: { Desktop: {}, Tablet: {}, Mobile: {} },
        gradient: {
            color: "linear-gradient(135deg,rgb(74,234,220) 0%,rgb(151,120,209) 20%,rgb(207,42,186) 40%,rgb(238,44,130) 60%,rgb(251,105,98) 80%,rgb(254,248,76) 100%)",
            width: { Desktop: {}, Tablet: {}, Mobile: {} }
        },
        image: {
            url: "",
            customImage:"",
            width: { Desktop: {}, Tablet: {}, Mobile: {} },
            place: { Desktop: {}, Tablet: {}, Mobile: {} },
            size: { Desktop: {}, Tablet: {}, Mobile: {} },
            opacity: 0.5,
            type: "space"
        }
    }  ,
    onChange,
    dataKey="frameData"
}) => {

    const localImages = Object.fromEntries(
        Array.from({ length: 12 }, (_, i) => [
            `image${i + 1}`, // Custom key like image5, image6, etc.
            require(`../../../../inc/assets/img/vayu-border-frames/${i + 1}.png`)
        ])
    );

    const [isVisible, setIsVisible] = useState(false);
    const [popoverAnchor, setPopoverAnchor] = useState();
    const toggleVisible = () => {setIsVisible((prev) => !prev);};

    const handleBorderImageClick = (value) => {
        const updatedFrameData = {
            ...frameData,
            image: {
                ...frameData.image,
                url: value,
            },
        };
    
        onChange(dataKey, updatedFrameData);
    };
    

    const resetAll = () => {
        const updatedFrameData = {
            ...frameData,
            image: {
                ...frameData.image,
                url: "",
            },
        };
    
        onChange(dataKey, updatedFrameData);
    };    
    
    const handlebordertype = (value) => {
        const updatedFrameData = {
            ...frameData,
            active: value,
        };
    
        onChange(dataKey, updatedFrameData);
    };
    

    const imageUrls = {
        none: "",
        image1: "https://www.w3schools.com/cssref/border.png",
        ...localImages, // Dynamically added local images
        custom: "custom"
    };

    return (
        <div className="vayu_blocks_border_frame">

            <div className="components-base-control__field_image">
                <div className="components-base-control__title_image">
                    <label className="components-base-control__label_image">{<VayuBlocksDeviceControl label={__('Border Type', 'vayu-blocks')}  />}</label>

                    <ToggleGroupControl
                        className="linking-controls_image"
                        __next40pxDefaultSize
                        __nextHasNoMarginBottom
                        isBlock
                        value={frameData.active}
                        onChange={(value)=>handlebordertype(value)}
                    >
                        <ToggleGroupControlOption
                            label={<Icon11 style={{ width: "27px", fill: "black", marginTop: "4px" }} />}                                            
                            value="color"
                        />
                        <ToggleGroupControlOption 
                            label={<Icon
                                class={frameData.type === "image" ? "vayu-blocks-image-svg-icon" : ""}
                                icon={BgImg} 
                            />}   
                            value="image"
                        />
                        <ToggleGroupControlOption
                            label={<Icon icon={ Bgclr } />}   
                            value="gradient"
                        />
                    </ToggleGroupControl>

                </div>
            </div> 

            {frameData.active === 'color' && (
                <Bordercontrol 
                    onChange={onChange}
                    dataKey={dataKey}
                    frameData={frameData} 
                />                      
            )} 

            {frameData.active === 'image' && (
                <>
                    <div className="vayu_blocks_animation_panel">
                        <ToolsPanel label={__('Image')} className="vayu_block_animation_name" resetAll={ resetAll }>

                            <ToolsPanelItem
                                className="vayu_blocks_animation_toolspanel_item"
                                hasValue={() => !!frameData?.image?.url}
                                label={__('Image','vayu-blocks')}
                                onDeselect={() => handleBorderImageClick('none')}
                                isShownByDefault
                            >

                            <Button
                                ref={setPopoverAnchor}
                                onClick={toggleVisible}
                                className={`block-editor-panel-animation-settings__dropdown ${isVisible ? 'is-open' : ''}`}
                            >

                                <HStack alignment="left">
                                    {!frameData?.image?.url || frameData?.image?.url === 'none' ? (

                                        <div  className={`vayu-blocks-panel-ihover vayu-blocks-none-button toolaspanel-size-none-button vayu_blocks_none`} ></div>

                                    ) : (
                                        <>
                                            <div style={{background:'none'}} className={`vayu_blocks_hstack_animation_panel_image vayu_blocks_hstack_animation_panel_image_color ${frameData?.image?.url === 'vayu_block_styling-effect3' ? 'vayu_block_styling-effect3-svg-extra-origin' : `${frameData?.image?.url}-svg`}`}>

                                                {frameData.image.url === "custom" ? (
                                                    <img src={frameData.image.customImage} width="55" height="30"/>
                                                ):(
                                                    <img  src={frameData.image.url} width="55" height="30"/>
                                                )}

                                              
                                            </div>

                                        </>
                                    )}

                                    <Text>{__(!frameData?.image?.url || frameData?.image?.url === 'none' ? 'Image' : Object.entries(imageUrls).find(([key, url]) => url === frameData.image.url)?.[0] || 'Custom' )}</Text>

                                    </HStack>
                            </Button>

                            </ToolsPanelItem>
                        
                        </ToolsPanel>

                        {isVisible && (
                            
                            <Image
                                popoverAnchor={popoverAnchor}
                                setIsVisible={setIsVisible}
                                frameData={frameData}
                                onChange={onChange}
                                dataKey={dataKey}
                                imageUrls={imageUrls}
                                handleBorderImageClick={handleBorderImageClick}
                            />
                        )}

                    </div>

                    <ImageControl
                        onChange={onChange}
                        dataKey={dataKey}
                        frameData={frameData}
                    />
                </>
                                    
            )}

            {frameData.active === 'gradient' && (
                                
                <Gradient
                    onChange={onChange}
                    dataKey={dataKey}
                    frameData={frameData}
                />
                                        
            )} 

            <Radiuscontrol
                onChange={onChange}
                dataKey={dataKey}
                frameData={frameData} 
            />
            
        </div>
    );
};